<template>
    <b-modal
        size="lg"
        title="Confirm Delete"
        ref="RemoveUser"
        @hidden="closeModal"
        centered>
        <div class="modal-form text-center py-4">
            <p>Are you sure you want to remove this user?</p>
        </div>
        <div slot="modal-footer" class="pt-4">
            <b-button
                variant="ghost"
                class="btn-cancel"
                style="margin-right: .25rem;" @click="closeModal('cancel')">
                Cancel
            </b-button>
            <b-button
                variant="primary"
                style="margin-left: .25rem;"
                @click="closeModal('remove')">
                OK
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "RemoveUser",
    props: ["user"],
    computed: {
        ...mapState("mechanicsCapping", ["modal"])
    },
    methods: {
        closeModal: function(type) {
            switch (type) {
                case "cancel":
                    this.$store.commit("mechanicsCapping/setModal", {
                        status: false,
                        type: "remove_user"
                    });
                break;
                case "remove":
                    this.$store.commit("mechanicsCapping/setDeleteUsers", this.modal.remove_user.id);
                    this.$store.commit("mechanicsCapping/setModal", {
                        status: false,
                        type: "remove_user",
                        index: this.modal.remove_user.index
                    });
                    this.$emit("removeUser", this.modal.remove_user.index);
                break;
            }
        }
    },
    watch: {
        "modal.remove_user.status": function(status) {
            if (status === true) {
                this.$refs.RemoveUser.show();
            } else {
                this.$refs.RemoveUser.hide();
            }
        }
    }
}
</script>
